export const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_PATH_SELECT':
      return { ...state, saveAt: action.path };
    case 'UPDATE_LOG_SIZE':
      return { ...state, logSize: action.size };
    default:
      break;
  }
};